import React from 'react'
import ThemeProvider from './src/styles/theme-provider'

export default ({ children }) => {
	return <ThemeProvider>{children}</ThemeProvider>
}
